import { render, staticRenderFns } from "./MemberCoupon.vue?vue&type=template&id=0b45fe0e&scoped=true&"
import script from "./MemberCoupon.vue?vue&type=script&lang=js&"
export * from "./MemberCoupon.vue?vue&type=script&lang=js&"
import style0 from "./MemberCoupon.vue?vue&type=style&index=0&id=0b45fe0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b45fe0e",
  null
  
)

export default component.exports